import moment from 'moment';

export const DEBUG_CONSOLE_MODE = window.localStorage.getItem('DEBUG_CONSOLE') === 'true';
const LENGTH = 60;

export const logEvent = (logger: string, message?: string, args?: any, color?: string) => {
    if (DEBUG_CONSOLE_MODE) {
        try {
            console.groupCollapsed(makeConsoleLogMessage(logger, message), ...makeConsoleMessageStyle(color));
            args && console.log(args);
            console.groupEnd();
        } catch (e) {}
    }
};

// mozno to abstrahovat este viac (zjednotit aj reframe/logMiddleware.ts a notifications/log.ts), a povolit farbu ako parameter?
export const makeConsoleLogMessage = (logger: string, event: string) => {
    return `%c[${logger}] %c${toFixedLength(event, LENGTH - (logger.length + 2))} %c@ ${moment().format(
        'HH:mm:ss:SS'
    )}`;
};

export const makeConsoleMessageStyle = color => [
    color ? `color: ${color}; font-weight: lighter;` : `font-weight: lighter;`,
    'color: inherit; font-weight: bold;',
    'color: gray; font-weight: lighter;'
];

export const toFixedLength = (string: string = '', length = 0) => {
    return string.padEnd(length).substring(0, length);
};
